import { useState, useEffect } from "react";
import {
  FiX,
  FiChevronLeft,
  FiChevronRight,
  FiDownload,
  FiZoomIn,
} from "react-icons/fi";
import { useSelectedLocation } from "../../context/LocationContext";

const TableMenu = () => {
  const { locationId } = useSelectedLocation();
  const [expandedImage, setExpandedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const menuImages =
    locationId === "neemuch"
      ? Array.from({ length: 7 }, (_, i) => {
          const pageNum = String(i + 1).padStart(4, "0");
          return {
            id: i + 1,
            src: encodeURI(
              `/images/menus/neemuch/table/Neemuch table_page-${pageNum}.jpg`
            ),
            alt: `Table Menu Page ${i + 1}`,
            category: "Neemuch",
          };
        })
      : Array.from({ length: 9 }, (_, i) => ({
          id: i + 1,
          src: encodeURI(`/images/menus/mandsaur/table/Mandsaur Table-images-${i}.jpg`),
          alt: `Table Menu Page ${i + 1}`,
          category: "Mandsaur",
        }));

  // Open lightbox
  const openLightbox = (index) => {
    setCurrentIndex(index);
    setExpandedImage(menuImages[index]);
    document.body.style.overflow = "hidden";
  };

  // Close lightbox
  const closeLightbox = () => {
    setExpandedImage(null);
    document.body.style.overflow = "auto";
  };

  // Navigate between images
  const navigate = (direction) => {
    const newIndex =
      (currentIndex + direction + menuImages.length) % menuImages.length;
    setCurrentIndex(newIndex);
    setExpandedImage(menuImages[newIndex]);
  };

  // Keyboard controls
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!expandedImage) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") navigate(1);
      if (e.key === "ArrowLeft") navigate(-1);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [expandedImage, currentIndex]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-50 to-stone-100 py-16 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-stone-800 mb-4 font-serif tracking-tight">
            Table Menu
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Explore our curated selection of fine dining experiences
          </p>
        </div>

        {/* Menu Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {menuImages.map((image, index) => (
            <div
              key={image.id}
              className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-500 hover:-translate-y-1"
              onClick={() => openLightbox(index)}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {/* Image with elegant overlay */}
              <div className="relative h-fit overflow-hidden">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                {/* <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
                  <div className="text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    <h3 className="text-xl font-semibold">{image.alt}</h3>
                    <p className="text-stone-200">{image.category}</p>
                  </div>
                </div> */}
                <div className="absolute top-4 right-4 bg-white/90 text-stone-800 p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <FiZoomIn size={20} />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox (Premium Design) */}
        {expandedImage && (
          <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
            <div className="relative w-full max-w-6xl max-h-[90vh]">
              {/* Navigation Arrows */}
              <button
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/10 text-white p-3 rounded-full z-20 hover:bg-white/20 transition-all duration-300 backdrop-blur-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(-1);
                }}
              >
                <FiChevronLeft size={28} />
              </button>
              <button
                className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/10 text-white p-3 rounded-full z-20 hover:bg-white/20 transition-all duration-300 backdrop-blur-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(1);
                }}
              >
                <FiChevronRight size={28} />
              </button>

              {/* Close Button */}
              <button
                className="absolute sm:top-0 -top-16 right-0 text-white hover:text-stone-300 z-20 transition-all duration-300"
                onClick={closeLightbox}
              >
                <FiX size={32} />
              </button>

              {/* Download Button */}

              {/* Image Display (Perfect Scaling) */}
              <div className="w-full h-full flex items-center justify-center">
                <img
                  src={expandedImage.src}
                  alt={expandedImage.alt}
                  className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableMenu;
